import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {faEdit, faTrash, faAngleDoubleLeft, faCheck} from "@fortawesome/free-solid-svg-icons";
import axios from 'axios'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {Link} from "react-router-dom";
import Table from "react-bootstrap/Table";
import 'bootstrap/dist/css/bootstrap.min.css';

const MySwal = withReactContent(Swal);

export default class DeletedComments extends Component {
    constructor() {
        super();
        this.state = {
            posts: []
        }
        this.getPost();
    }


    render() {
        return (
            <div className="index">

                <div className="table">

                    <Table striped bordered responsive>
                        <thead>
                        <tr>
                            <th>عنوان مطلب</th>
                            <th>کامنت</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.posts.map((item) => this.renderItem(item))
                        }
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }

    renderItem(item) {

        return (
            <tr key={item._id}>
                <td>{item.post.title}</td>
                <td style={{width: '40%'}}>{item.comment}</td>
                <td>
                    <button className="success" onClick={() => this.accept(item._id)}>
                        <FontAwesomeIcon icon={faCheck}/>
                    </button>
                </td>

            </tr>
        )
    }

    getPost() {
        axios.get('https://arianaapp.arianaapply.com/panel/deleted-comment')
            .then((response) => {
                this.setState({posts: response.data})
            }).catch((err) => {
            console.log(err);

            MySwal.fire({
                title: 'دوباره امتحان کنید',
                icon: 'error'
            })
        })
    }


    //accept comment
    accept(id, index) {

        axios.post('https://arianaapp.arianaapply.com/panel/submit-comment', {
            id: id
        })
            .then((response) => {
                let posts = [...this.state.posts];
                posts.splice(index, 1);
                this.setState({posts})

            }).catch((err) => {
            console.log(err);

            MySwal.fire({
                title: 'دوباره امتحان کنید',
                icon: 'error'
            })
        })
    }
}